import { ReactComponent as baseBody} from "./resources/body/base-body.svg";
import { ReactComponent as baseBodyBack} from "./resources/body/body-back/body1-back.svg";
import { ReactComponent as baseBodyLeft} from "./resources/body/body-left/body1-left1.svg";
import { ReactComponent as baseBodyRight} from "./resources/body/body-right/body1-right1.svg";

import { ReactComponent as body2} from "./resources/body/body2.svg";
import { ReactComponent as body2Back} from "./resources/body/body-back/body2-back.svg";
import { ReactComponent as body2Left} from "./resources/body/body-left/body2-left1.svg";
import { ReactComponent as body2Right} from "./resources/body/body-right/body2-right1.svg";


import { ReactComponent as baseFace} from "./resources/face/face1.svg";
import { ReactComponent as baseFaceBack} from "./resources/face/face-back/face1-back.svg";
import { ReactComponent as baseFaceLeft} from "./resources/face/face-left/face1-left.svg";
import { ReactComponent as baseFaceRight} from "./resources/face/face-right/face1-right.svg";

import { ReactComponent as face2} from "./resources/face/face2.svg";
import { ReactComponent as face2Back} from "./resources/face/face-back/face2-back.svg";
import { ReactComponent as face2Left} from "./resources/face/face-left/face2-left.svg";
import { ReactComponent as face2Right} from "./resources/face/face-right/face2-right.svg";


import { ReactComponent as baseHair} from "./resources/hair/base-hair.svg";
import { ReactComponent as baseHairRight} from "./resources/hair/hair-right/hair1-right.svg";
import { ReactComponent as baseHairLeft} from "./resources/hair/hair-left/hair1-left.svg";
import { ReactComponent as baseHairBack} from "./resources/hair/hair-back/hair1-back.svg";

import { ReactComponent as hair1} from "./resources/hair/hair1.svg";
import { ReactComponent as hair3} from "./resources/hair/hair3.svg";
import { ReactComponent as hair4} from "./resources/hair/hair4.svg";


export const AVAILABLE_BODIES = [baseBody, body2];
export const AVAILABLE_BODIES_RIGHT = [baseBodyRight, body2Right];
export const AVAILABLE_BODIES_LEFT = [baseBodyLeft, body2Left];
export const AVAILABLE_BODIES_BACK = [baseBodyBack, body2Back];

// Faces
export const AVAILABLE_FACES = [baseFace, face2];
export const AVAILABLE_FACES_RIGHT = [baseFaceRight, face2Right];
export const AVAILABLE_FACES_LEFT = [baseFaceLeft, face2Left];
export const AVAILABLE_FACES_BACK = [baseFaceBack, face2Back];


// HairStyles
export const AVAILABLE_HAIRSTYLES = [baseHair, hair1, hair3, hair4];
export const AVAILABLE_HAIRSTYLES_RIGHT = [baseHairRight, hair1, hair3, hair4];
export const AVAILABLE_HAIRSTYLES_LEFT = [baseHairLeft, hair1, hair3, hair4];
export const AVAILABLE_HAIRSTYLES_BACK = [baseHairBack, hair1, hair3, hair4];



export const DEFAULT_NAMES = ["Zane", "Nova", "Flux", "Raze", "Vexx", "Kyro", "Dash", "Jolt", "Pax", "Xeno", "Thor", "Vibe", "Flux", "Zix", "Ace", "Nix", "Vox", "Rex", "Jet", "Ark", "Sky", "Lux", "Fizz", "Zep", "Neo", "Vox", "Ash", "Max", "Orb", "Zin", "Hex", "Jin", "Ray", "Sol", "Vox", "Wren", "Zen", "Ty", "Kip", "Finn", "Jay", "Bix", "Zed", "Jax", "Lux", "Zen", "Vox", "Tay", "Rex", "Ace", "Yax", "Zyn", "Dex", "Ax", "Caz", "Kit", "Rio", "Tay", "Zix", "Pax", "Jex", "Max", "Roy", "Zen", "Kai", "Ziv", "Nox", "Rex", "Vox", "Ray", "Sky", "Vox", "Jay", "Pip", "Jax", "Rex", "Taz", "Kai", "Sol", "Zen", "Vox", "Kit", "Zin", "Dex", "Kip", "Ash", "Jet", "Max", "Zed", "Jin", "Roy", "Lux", "Vox", "Pax", "Zyn", "Ace", "Tay", "Caz", "Finn", "Vex"]

